var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.666016H2.99999C2.26666 0.666016 1.66666 1.26602 1.66666 1.99935V11.3327H2.99999V1.99935H11V0.666016ZM13 3.33268H5.66666C4.93332 3.33268 4.33332 3.93268 4.33332 4.66602V13.9993C4.33332 14.7327 4.93332 15.3327 5.66666 15.3327H13C13.7333 15.3327 14.3333 14.7327 14.3333 13.9993V4.66602C14.3333 3.93268 13.7333 3.33268 13 3.33268ZM5.66666 13.9993H13V4.66602H5.66666V13.9993Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.9ef56e97994de38be54a4eaff733bfbe.svg";
export { ForwardRef as ReactComponent };